/* eslint eol-last: 'off', block-spacing: 'off', brace-style: 'off' */
import current from '@/scripts/current';
import variableSelectionHelper from '@/scripts/variableSelectionHelper';
import store from '@/store';
import commonModelHelper from '@/scripts/commonModelHelper';
import common from '@/scripts/common';

function build(apiResults) {
    var parms = {
        dependentVariable: variableSelectionHelper.getVariableWithGroupAndCategories(apiResults, 'dep', 1, current.selectionModel.v.dependent.variable.variable),
        independentVariables: current.selectionModel.v.independent.map((v, i) =>
            variableSelectionHelper.getVariableWithGroupAndCategories(apiResults, 'ind', i + 1, v.variable.variable))
    };
    if (!apiResults.results)
        apiResults.results = [];
    var interceptResults = apiResults.results.filter(r => r.variableType === 'Intercept');
    var interceptData = interceptResults && interceptResults.length > 0 && interceptResults[0].levelStatistics ? interceptResults[0].levelStatistics[0] : {};
    var independentResults = apiResults.results.filter(r => r.variableType === 'Independent');
    if (window.inAutomatedTesting && current.selectionModel.reference.dependent < 1)
        current.selectionModel.reference.dependent = 1;
    var referenceCategoryId = current.selectionModel.reference.dependent;
    // console.log('current.selectionModel', current.selectionModel.reference.independent);
    var selectedCategoryTitle = parms.dependentVariable.categories[referenceCategoryId - 1].title;
    var statistics = toStatisticsModel(apiResults.testStatistics);

    const results = {
        parms: parms,
        interceptData: interceptData,
        dependentModelCategory: selectedCategoryTitle,
        modelTestStatistics: statistics,
        recordTotals: apiResults.recordTotals,
        independentModel: independentResults.map(i => toIndependentModel(i, parms.independentVariables,
            current.selectionModel.reference.independent)),
        missingData: commonModelHelper.getMissingData(parms.independentVariables)
    };
    return results;
}

function toIndependentModel(set, independentVariables, references) {
    const variableIndex = set.variableNumber - 1;
    const variableSelection = independentVariables[variableIndex];
    return {
        id: set.variableNumber,
        key: variableSelection.variable.variable,
        title: variableSelection.variable.variableTitle,
        levels: toIndependentLevels(set.levelStatistics, variableSelection, references[variableIndex])
    }
}

function toIndependentLevels(statistics, variableSelection, referenceLevel) {
    const categories = variableSelection.categories;
    const isContinuous = !categories || categories.length === 0 || !categories[0].id;
    // console.log('independent', isContinuous, categories, statistics, variableSelection.type);

    let results = [];
    if (isContinuous)
        results = [{
            id: 1,
            key: variableSelection.variable.variable + "_1",
            title: '(continuous)',
            isReference: false,
            statistics: statistics[0],
            totalSourceRecords: commonModelHelper.getNumberOfSourceRecords(0, variableSelection.type)
        }];
    else results = categories.map(l => toIndependentLevel(statistics, variableSelection, referenceLevel, l))
        .sort((a, b) => a.id - b.id);
    results.noData = results.totalSourceRecords === 0;
    return results;
}

function toIndependentLevel(statistics, variableSelection, referenceLevel, l) {
    const totalSourceRecords = commonModelHelper.getNumberOfSourceRecords(l.code, variableSelection.type); // independent[variableIndex].levels[categoryIndex].totalSourceRecords
    return {
        id: l.id,
        key: variableSelection.variable.variable + "_" + l.id,
        title: l.title,
        isReference: referenceLevel === l.id,
        statistics: common.find(statistics, s => s.level === l.id), //
        totalSourceRecords: totalSourceRecords
    };
}

function abcd(s) {
    return {
        [s.variable]: s
    }
}

function toStatisticsModel(statistics) {
    if (!statistics || statistics.length === 0)
        return {};
    return Object.assign(...statistics.map(s => ({ [s.variable]: s })));
}


function addTotalSourceRecords(category, variableSelection) {
    return {
        id: category.id,
        title: category.title,
        totalSourceRecords: commonModelHelper.getNumberOfSourceRecords(category.code, variableSelection.type)
    }
}

export default {
    build
}